import { Component } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Row,
  Col,
  Button,
} from 'reactstrap';
import { renderIcon } from '../../../shared/components/icons';
import { ITeamMemberItem, ITeamMembers } from '../../../types/campaign';
import { getGroupLabel } from '~/shared/utils';

export interface TeamSectionProps {
  members: ITeamMembers;
}

export const TeamMemberCard = (member: ITeamMemberItem) => {
  const {
    id,
    person,
    relationship_to_patient,
    is_primary,
    access,
    permissions,
  } = member;
  const history = useHistory();
  const { first_name, last_name } = person;
  const name = `${first_name} ${last_name}`;
  function showItems() {
    return permissions.map((item, i) => {
      return (
        <div key={i} className='me-2'>
          {renderIcon(item)}
        </div>
      );
    });
  }

  const accessLabel = getGroupLabel(access);

  return (
    <Card
      className='h-100'
      style={{
        boxShadow: '0 12px 24px rgba(0, 0, 0, 0.25)',
      }}
    >
      <CardBody>
        <CardTitle
          style={{
            fontWeight: '900',
          }}
        >
          {name}
        </CardTitle>
        <CardText>
          {relationship_to_patient?.name}
          <br />
          {accessLabel}
        </CardText>
        <div className='d-flex mb-3' style={{ fontSize: '22px' }}>
          {showItems()}
        </div>
        <Button
          onClick={() => history.push('/team/edit/' + id, { member })}
          color='link'
          className='ps-0'
        >
          Edit
        </Button>
      </CardBody>
    </Card>
  );
};

export const TeamSection = ({ members }: TeamSectionProps) => {
  if (members.length == 0) return <Card></Card>;

  function showItems() {
    return members.map((member, i) => {
      return <Col key={i}>{TeamMemberCard(member)}</Col>;
    });
  }

  return (
    <div className='mt-5 pb-5'>
      <div className='d-sm-flex align-items-center mb-4'>
        <h4 className='mb-sm-0'>Team</h4>
        <NavLink to='/team/add' className='btn btn-outline-dark btn-sm ms-sm-4'>
          {renderIcon('add')}
          Add Team Member
        </NavLink>
      </div>

      <Row className='row-cols-2 row-cols-lg-3 row-cols-xl-5 g-3 g-md-4'>
        {showItems()}
      </Row>
    </div>
  );
};
